export const API_URL = 'https://api.krlmedia.com/production';
export const APP_VERSION = 'V: 1.0.0';
export const TERMS_URL = 'https://krlmedia.com/terms';
export const SENTRY_DSN =
  'https://c1a46a0d729b4ac8aa7668506dd72176@o570690.ingest.sentry.io/5717836';
export const STRIPE_PUBLIC_KEY =
  'pk_live_51JL5d7GPCo5mfHNMjrSm8Ds8banY6l92YqFLgru3rz6yXkIAirFc92vCNJ7xn5GYV7Iv7tpkYrbiTIwxI3tWJ5sx00Rur0af10';
export const ENCRYPT_KEY = 'SuppOrt@myd@clouD';
